import { useCallback } from 'react';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { AccessRequestCapabilityResponse } from './types.tsx';

export const useConfluenceRequestCapabilities = (cloudId: string) => {
	const resource = `ari:cloud:confluence::site/${cloudId}`;
	return useCallback(async (): Promise<string> => {
		try {
			return fetchConfluenceRACapability(resource);
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			fireErrorAnalytics({
				meta: {
					id: 'useConfluenceRequestCapabilitiesCheck',
					packageName: 'jiraCrossJoinThirdPartyNudges',
				},
				error,
				sendToPrivacyUnsafeSplunk: true,
			});
			throw new Error('Get request capabilities error');
		}
	}, [resource]);
};

const fetchConfluenceRACapability = async (resource: string): Promise<string> => {
	const URL = getConfluenceRequestCapabilitiesUrl(resource);
	const response = await fetchJson<AccessRequestCapabilityResponse>(URL, {
		credentials: 'include',
	});
	const requestCapabilities = response.results[resource];
	return requestCapabilities;
};

const getConfluenceRequestCapabilitiesUrl = (resource: string) => {
	const params = new URLSearchParams({
		resource,
	});

	return `/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`;
};
